exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-banner{display:flex;border:1px solid #dfe2e7;padding:1.714rem;align-items:center;border-radius:.285rem}.cap-banner-flexDisplay{display:flex;flex-grow:1;align-items:center}.cap-banner-logo{display:flex;align-items:center;position:relative;height:3.428rem;width:3.428rem;margin-right:1.714rem}.cap-banner-logo .text-label{position:absolute;right:50%;top:50%;transform:translate(50%, -50%)}\n", ""]);

// exports
